export default "__VITE_ASSET__CQOfl3vM__"